import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface StoriesWrittenByGradeResponse {
  stories_written_by_grade: {
    student_count: number
    average_stories_written: Nullable<number>
    stories: {
      grade_position: number
      student_count: number
      story_count: number
    }[]
  }
}

export type StoriesWrittenByGradeData = StoriesWrittenByGradeResponse['stories_written_by_grade']

export async function storiesWrittenByGrade(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<StoriesWrittenByGradeData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('stories_written_by_grade', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<StoriesWrittenByGradeResponse>(url, query)
  if (!data) return null

  const { stories_written_by_grade } = data

  if (stories_written_by_grade.stories.length === 0) return null

  return {
    ...stories_written_by_grade,
    stories: [...stories_written_by_grade.stories].sort((a, b) => a.grade_position - b.grade_position),
  }
}
